import React from 'react';
import { useSelector } from 'react-redux';
import { Skeleton } from 'antd';

import {
  BenchmarkWrapper,
  BenchmarkTextWrapper,
  BenchmarkValueWrapper,
  BenchmarkContentWrapper,
} from './styled';
import { humanize } from '@utils';
import {
  spiValueSelector,
  spiIntervalSelector,
  spiLoadingSelector,
  spiValueBestSelector,
} from '@store/overviewDashboard/benchmark/selectors';
import { selectedKPIConfigSelector } from '@store/overviewDashboard/base/selectors';
import { isKpiValid } from '../sub-opportunities/Helper';

const NA_STATUS = [-1, 'NA']; // Api gives NA in case of no value, for dimension table putting default value as -1 in case of no value

function Benchmark() {
  const spiValue = useSelector(spiValueSelector);
  const spiInterval = useSelector(spiIntervalSelector);
  const { loading } = useSelector(spiLoadingSelector);
  const selectedKPIConfig = useSelector(selectedKPIConfigSelector);
  const spiBestValue = useSelector(spiValueBestSelector);

  // If not CONVIVA GOOD/BEST then do not show benchmark
  const isKpiFound = isKpiValid(selectedKPIConfig);
  const spiBenchmarkValue = spiValue || spiBestValue;
  if (!isKpiFound || !spiBenchmarkValue) {
    return null;
  }

  if (loading) {
    return (
      <BenchmarkContentWrapper>
        <Skeleton active title={false} paragraph={{ rows: 2, width: 150 }} />
      </BenchmarkContentWrapper>
    );
  }
  const humanizedValue = NA_STATUS.includes(spiBenchmarkValue)
    ? 'NA'
    : humanize(spiBenchmarkValue, '');
  return (
    <BenchmarkContentWrapper>
      <BenchmarkWrapper>
        <BenchmarkTextWrapper>{spiInterval}</BenchmarkTextWrapper>
        <BenchmarkTextWrapper>Benchmark</BenchmarkTextWrapper>
        <BenchmarkValueWrapper>{humanizedValue}</BenchmarkValueWrapper>
      </BenchmarkWrapper>
    </BenchmarkContentWrapper>
  );
}

export default Benchmark;
